import { CompanySwitcherFallback } from '@/components/layout/breadcrumbs/company-switcher/fallback'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Skeleton } from '@/components/ui/skeleton'

export const BreadcrumbsSkeleton = () => {
  return (
    <Breadcrumb className="flex items-center h-[48px]">
      <BreadcrumbList>
        <CompanySwitcherFallback />
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage className="px-2">
            <Skeleton className="h-4 w-[100px]" />
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
